export default "__VITE_ASSET__2df3edfe__"